<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs"> Tercerización de pagos / Nuevo Beneficiario</p>
        <h2 class="">Tercerización de pagos</h2>
    </div>
</div>
<div class="dx-card content-block pt-3">
    <!-- TOP CONTAINER  -->
    <div class="flex flex-nowrap">
        <!-- Left  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Datos del beneficiario</h3>
            <div class="round-border-2 pt-0">
                <div class="dx-field mb-0 ">
                    <div class="dx-field-label">Es persona moral</div>
                    <div class="dx-field-value">
                        <dx-switch [(value)]="newBeneficiary.beneficiaryIsInc"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">RFC</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.rfc" class="uper-case">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Nombre Comercial</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.beneficiaryComercialName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="newBeneficiary.beneficiaryIsInc">
                    <div class="dx-field-label">Razón social</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.beneficiaryLegalName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="!newBeneficiary.beneficiaryIsInc">
                    <div class="dx-field-label">Nombre</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.beneficiaryFirstName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="!newBeneficiary.beneficiaryIsInc">
                    <div class="dx-field-label">Segundo nombre</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.beneficiarySecondName"> </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="!newBeneficiary.beneficiaryIsInc">
                    <div class="dx-field-label">Apellido paterno</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.beneficiaryLastName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" *ngIf="!newBeneficiary.beneficiaryIsInc">
                    <div class="dx-field-label">Apellido materno</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.beneficiarySecondLastName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Teléfono </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.phone" mask="+52 (000) 000-0000">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-text-box>
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Email </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.email">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="email" message="Email es inválido">
                                </dxi-validation-rule>
                            </dx-validator> -->
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Notas </div>
                    <div class="dx-field-value">
                        <dx-text-area [height]="90" [(value)]="newBeneficiary.notes">
                        </dx-text-area>
                    </div>
                </div>
            </div>
        </div>
        <!-- Right  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Datos del beneficiario</h3>
            <div class="round-border-2">
                <div class="dx-field">
                    <div class="dx-field-label">Dirección </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.adress">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Ciudad </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.city">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Estado </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.state">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Código postal </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newBeneficiary.zip">
                            <!-- <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator> -->
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Banco</div>
                    <div class="dx-field-value">
                        <dx-select-box [searchEnabled]="true" [dataSource]="bancos" displayExpr="name" valueExpr="name" [(value)]="newBeneficiary.bank">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">CLABE</div>
                    <div class="dx-field-value">
                        <dx-text-box maxLength="18" [(value)]="newBeneficiary.clabe">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label"># Cuenta</div>
                    <div class="dx-field-value">
                        <!-- <dx-number-box [(value)]="newBeneficiary.accountNumber" [showSpinButtons]="false">
                            <dx-validator>
                                <dxi-validation-rule type="range" min="1" message="Error"></dxi-validation-rule>
                            </dx-validator>
                        </dx-number-box> -->
                        <dx-text-box [(value)]="newBeneficiary.accountNumber">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label"></div>
                    <div class="dx-field-value mt-2">
                        <dx-button id="button" [useSubmitBehavior]="true" type="default"
                            (onClick)="saveBeneficiary($event)" text="Guardar beneficiario">
                        </dx-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>